import DropZoneComponent from "components/Shared/Dropzone";
import { FileItem } from "./FileItemPreview";
import { FileStructure } from "interfaces";
import { useSelector, useDispatch } from "react-redux";
import { GlobalState, setPreviewFile } from "app/slices/globalSlice";

export const UploadOrShow = ({
  multiUpload,
  files,
  category,
  doDrop,
  handleDelete,
  label,
  isUploading,
  showPreview,
}: {
  category: string;
  multiUpload: boolean;
  files?: Array<FileStructure>;
  handleDelete?: any;
  doDrop: any;
  label: string;
  isUploading?: boolean;
  showPreview?: boolean;
}) => {
  const { uploading } = useSelector<any, GlobalState>((state) => state.global);
  const dispatch = useDispatch();

  const uploadComponent = () => {
    if (!multiUpload && files && files.length > 0) return null;
    return (
      <DropZoneComponent
        disable={!multiUpload && uploading.includes(category)}
        doDrop={doDrop}
        label={label}
        isUploading={isUploading}
      />
    );
  };

  const itemComponent = () => {
    return files?.map(({ filename, location, file }, index) => {
      const handlePreviewClick =
        showPreview && file
          ? () => {
              dispatch(
                setPreviewFile({
                  previewFile: file ? URL.createObjectURL(file) : location!,
                }),
              );
            }
          : undefined;

      return (
        <div key={`${filename}-${index}`} className="flex flex-col gap-2 mb-2">
          <FileItem
            filename={filename}
            handleDelete={handleDelete}
            onClick={handlePreviewClick}
          />
        </div>
      );
    });
  };
  return (
    <>
      {itemComponent()}
      {uploadComponent()}
    </>
  );
};
